import {
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import AttachedFileIcon from "../icons/AttachedFileIcon";
import FileInput from "../FileInput";
import PrimaryButton from "../PrimaryButton";
import { useRef } from "react";

type AttachedFileModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClick: (files: FileList) => void;
};

function AttachedFileModal({ isOpen, onClose, onClick }: AttachedFileModalProps) {
  const ref = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    if (ref.current?.files) {
        onClick(ref.current.files)
    }
    onClose()
  };
  return (
    <Modal isOpen={isOpen} onClose={() => {}} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
      <ModalContent maxW={"none"} w="1000px">
        <ModalHeader>
          <Flex alignItems={"center"}>
            <Flex
              w="48px"
              h="48px"
              bg="zinc.50"
              border="solid 1px"
              borderColor="brand.100"
              justifyContent="center"
              alignItems="center"
              borderRadius={100}
              mr="8px"
            >
              <AttachedFileIcon
                w="24px"
                h="24px"
                color="brand.700"
              ></AttachedFileIcon>
            </Flex>
            <Text lineHeight={"48px"}>Ajouter un document</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton onClick={onClose} />

        <ModalBody>
          <FileInput name={"files"} ref={ref}></FileInput>
        </ModalBody>

        <ModalFooter borderTop="solid 1px #E2E8F0">
          <PrimaryButton onClick={handleClick}>Ajouter</PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AttachedFileModal;
